import axios from '@/libs/api.request'

// 菜单组列表
export const apiGroupPermissionList = data => {
  return axios.request({
    url: '/agency/group_permission',
    method: 'get',
    data
  })
}
// 菜单组详情
export const apiGroupPermissionDetail = (id, data) => {
  return axios.request({
    url: `/agency/group_permission/${id}`,
    method: 'get',
    data
  })
}
// 添加菜单组
export const apiGroupPermissionAdd = data => {
  return axios.request({
    url: '/agency/group_permission',
    method: 'post',
    data
  })
}
// 修改菜单组
export const apiGroupPermissionUpdate = (id, data) => {
  return axios.request({
    url: `/agency/group_permission/${id}`,
    method: 'put',
    data
  })
}
// 删除菜单组
export const apiGroupPermissionDelete = (id, data) => {
  return axios.request({
    url: `/agency/group_permission/${id}`,
    method: 'delete',
    data
  })
}

// 获取所有菜单组
export const apiGroupPermissionMenu = (data) => {
  return axios.request({
    url: `/agency/group_permission_all`,
    method: 'get',
    data
  })
}
